const types = {
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  GET_USERS_START: 'GET_USERS_START',
  GET_USERS_FAILURE: 'GET_USERS_FAILURE',
  UPDATE_USER_START: 'UPDATE_USER_START',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  GET_USER_BILLING_SUCCESS: 'GET_USER_BILLING_SUCCESS',
  GET_USER_SHIPPING_SUCCESS: 'GET_USER_SHIPPING_SUCCESS',
  GET_FIND_USER_FOR_PROMO_CODE_SUCCESS: 'GET_FIND_USER_FOR_PROMO_CODE_SUCCESS',
  GET_PM_USERS_START: 'GET_PM_USERS_START',
  GET_PM_USERS_SUCCESS: 'GET_PM_USERS_SUCCESS',
  GET_PM_USERS_FAILURE: 'GET_PM_USERS_FAILURE',
  GET_USER_BY_ID_SUCCESS: 'GET_USER_BY_ID_SUCCESS',
};
export default types;
